import { DatePicker, Modal } from 'antd';
import moment from 'moment';
import * as React from 'react';

interface ILocalProps {
    companyID: number,
    companyName: string,
    onCancel: () => void,
    onGracePeriodChange: (date: moment.Moment, dateString: string) => void,
    onSave: () => void,
    gracePeriod: moment.Moment|undefined,
}

const disabledDate = (current?: moment.Moment): boolean =>  {
    // Can not select days before today
    return !!current && current < moment().endOf('day');
}

const GracePeriodModal: React.SFC<ILocalProps> = (props: ILocalProps): JSX.Element => {
    return (
        <Modal
            title={`Set Grace Period for ${props.companyName} (${props.companyID})`}
            visible={true}
            onCancel={props.onCancel}
            onOk={props.onSave}
            okText="Save"
        >
            <h4>Grace Period</h4>
            <p>Please select a date for the user's grace period to expire. Once it expires, the user's credit card will be charged.</p>
            <DatePicker placeholder="Grace Period" onChange={props.onGracePeriodChange} value={props.gracePeriod} disabledDate={disabledDate} />
        </Modal>
    );
}

export default GracePeriodModal;
